import { Box, Link } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CorpTypeList2,
  FacilityKind,
  SexFlug,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import TkCheckbox from "../../components/atoms/TkCheckbox";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkStrpper from "../../components/atoms/TkStepper";
import TkTable from "../../components/atoms/TkTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkCsvUpload from "../../components/molecules/TkCsvUpload";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_STA014_Request, IAPI_STA017_Response } from "../../type/apiType";
import { TkGetCode } from "../../utils/TkGetCode";
import { changeAmountFormat } from "../../utils/useTools";
import "./_style.scss";
import {
  httpAPI_STA007,
  httpAPI_STA014,
  httpAPI_STA017,
  httpAPI_FAC042,
} from "./api/request";
import {
  infoManualThree,
  infoManualTwo,
  stepperData,
  tableHeadList,
} from "./parts";
import { CheckedList } from "../../type/apiType/IAPI_STA007";
import TkTitle from "../../components/atoms/TkTitle";
import dayjs from "dayjs";

/**
 * SCRC050104コンポーネント。
 * このコンポーネントは、  stepperData,tableHeadList,infoManual,infoManualTwo,infoManualThreeをレンダリングします。
 * @returns JSX.Element SCRC050104 新規登録職員一覧
 */
const SCRC050104 = () => {
  const navigate = useNavigate();
  //ボタンの表示と非表示
  const [showButton, setShowButton] = useState(false);
  //削除用APIリクエスト
  const [httpDeleteReq, setDeleteHttpReq] = useState<IAPI_STA014_Request>();
  //テーブルのBody
  const [BodyList, setBodyList] = useState<any>([]);
  //削除ダイヤログ
  const [openSuccessDelete, setOpenSuccessDelete] = useState(false);
  //業務用Contextを更新するState
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [openUploadComplete, setOpenUploadComplete] = useState(false);
  //グローバルContextを更新するState
  const { state, setState } = useContext(GlobalContext);
  const [disOver, setDisOver] = useState(false);
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiko
    ? businessState?.common?.contractorNo
    : state.authInfo?.contractorNo;
  const businessStateData = businessState.job_15;

  // チェック済みリスト
  const [checkedList, setCheckedList] = useState<CheckedList[]>([]);

  useEffect(() => {
    //初期表示時に初期表示APIを呼び出し、取得結果とステッパーをState変数に設定する。
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //初期表示API
  const handleInit = async () => {
    // 職員情報登録一覧参照API呼び出し
    try {
      const res: IAPI_STA017_Response = await httpAPI_STA017({
        applyId: businessStateData?.applyId!,
        facilityNo: businessStateData?.facilityNo!,
        businessType: businessState.common?.businessType!,
      });

      if (res.resultCd === "I0000") {
        let bodyinput: any = res.staffList?.map((item) => [
          {
            children: `${item.staffNo}:${item.staffNameKanji}`,
          },
          {
            children: item.birthday,
          },
          {
            children: TkGetCode(SexFlug, item.sex),
          },
          {
            children: item.joinCapacity,
          },
          {
            children: changeAmountFormat(item.salaryTableAmt ?? 0),
            className: item.salaryTableAmt,
            align: "right",
          },
          {
            children: changeAmountFormat(item.salaryAdjustmentAmt ?? 0),
            align: "right",
          },
          {
            children: (
              <Box className="buttonInTable">
                <TkButton
                  data-testid="fixButton"
                  onClick={() => handleEditClick(item.staffNo!)}
                >
                  修正
                </TkButton>
                <TkButton
                  data-testid="deleteButton"
                  onClick={() => {
                    setDeleteHttpReq({
                      facilityNo: businessStateData?.facilityNo,
                      staffNo: item.staffNo!,
                      applyId: businessStateData?.applyId!,
                      contractorNo,
                      updateDateTime: item.updateDatetime!,
                    });
                    setOpenSuccessDelete(true);
                  }}
                >
                  削除
                </TkButton>
              </Box>
            ),
          },
          {
            //※欄は残すが何も表示しない
            children: "",
          },
        ]);

        setBodyList(bodyinput);

        //以下に該当する職員はすべて登録しました
        setDisOver(res.registerCompletedFlg === "1");
        setState({
          ...state,
          errorMsgId: "",
        });

        if (
          //持回情報.加入止めフラグまたは、持回情報.部分解除フラグのいずれかが1の場合、ボタンを非表示する
          businessStateData?.noJoinFlg === "1" ||
          businessStateData?.partialReleaseFlg === "1" ||
          ([
            CorpTypeList2["学校法人"],
            CorpTypeList2["学校法人（認定こども園）"],
          ].includes(res.businessOwnerClass as CorpTypeList2) &&
            new Date(res.contractDate!) >= new Date("2015/04/01"))
        ) {
          setShowButton(true);
        }

        setBusinessState({
          ...businessState,
          job_15: {
            ...businessState.job_15,
            staffNo: "",
            registrationProcedureInfo: {},
            pastContractCancelDate: res.pastContractCancelDate,
          },
        });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  //修正ボタン用イベント
  const handleEditClick = (staffNo: string) => {
    setBusinessState({
      ...businessState,
      job_15: {
        ...businessState.job_15,
        staffNo,
      },
    });
    navigate("/SCRC060108", {
      state: {
        applyId: businessStateData?.applyId,
      },
    });
  };

  //職員登録
  const handleRegistration = () => {
    navigate("/SCRC060108");
  };

  //削除用APIを呼び出して、その後初期表示するイベント
  const handleOKDelete = async () => {
    try {
      const res = await httpAPI_STA014({
        ...httpDeleteReq,
      });

      if (res.resultCd === "I0000") {
        setOpenSuccessDelete(false);
        handleInit();
        setState({ ...state, errorMsgId: "" });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  //登録完了ボタン押下時
  const onHandleUpdateAPI = async () => {
    // 業務チェック
    if (BodyList.some((item: any) => !item[4].className)) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0101E",
      });
      return;
    }
    try {
      const res = await httpAPI_FAC042({
        applyId: businessStateData?.applyId!,
        facilityNo: businessStateData?.facilityNo!,
        businessType: businessState.common?.businessType!,
      });
      if (res.resultCd === "I0000") {
        setState({ ...state, errorMsgId: "" });
        navigate("/SCRC050103");
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handReplacement = () => {
    navigate("/SCRC060111", {
      state: {
        applyId: businessStateData?.applyId,
        facilityNo: businessStateData?.facilityNo,
        facilityName: businessStateData?.facilityName,
      },
    });
  };

  const parts = infoManualTwo.split(/(ヘルプマーク②)/g);

  // 一括アップロードボタン押下時に更新用APIを呼び出すイベント
  const handleUpload = async (csvData: any) => {
    const staffArr = csvData.map((item: any) => {
      return {
        facilityNo: businessStateData?.facilityNo,
        facilityName: item.facilityName,
        staffNameKana: `${item.staffLastNameHalfKana} ${item.staffFirstNameHalfKana}`,
        staffNameKanji: `${item.staffLastName}　${item.staffFirstName}`,
        birthday: item.birthDate,
        sex: item.gender,
        joinDate: businessStateData?.pastContractCancelDate
          ? dayjs(businessStateData?.pastContractCancelDate)
              .add(1, "day")
              .format("YYYY/MM/DD")
          : businessStateData?.foundDate,
        joinCapacity: item.membershipQualification,
        jobCd: item.jobType,
        salaryTableAmt: parseInt(item.salaryScaleAmount),
        salaryAdjustmentAmt: parseInt(item.salaryAdjustmentAmount),
        masPastFlg: item.hasBeenMutualAidStaff,
        masQuitReason: item.reasonForNotBeingMutualAidStaff,
        masQuitDate: item.dateOfNoLongerBeingMutualAidStaff,
        bCorpName: item.previousMutualAidContractorName,
        bContractNo: item.previousMutualAidContractorNumber,
        bStaffNo: item.previousStaffNumber,
      };
    });

    try {
      const res = await httpAPI_STA007({
        contractorNo:
          state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
            ? businessState?.common?.contractorNo
            : state?.authInfo?.contractorNo,
        applyId: businessStateData?.applyId || 0,
        tempSaveStep: businessStateData?.tempSaveStep || 0,
        businessType: businessState.common?.businessType || "",
        staffList: staffArr,
        checkedList: checkedList,
      });

      setCheckedList(res.checkedList || []);

      if (res.resultCd === "I0000") {
        handleInit();
        setState({
          ...state,
          errorMsgId: "",
        });
        setCheckedList([]);
        setOpenUploadComplete(true);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRC050104PageForTest" className="SCRC050104">
      <TkStrpper steps={stepperData} activeStep={0} />
      <Box className="infoManual">
        <span>当該施設・事業に在籍している</span>
        <span className="boldText">加入要件を満たす職員は全て登録</span>
        <span>してください。</span>
        <TkHelpIcon
          helpMessage={
            <>
              加入要件については
              <a
                href={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/≪別紙≫加入要件について.pdf`}
                target="_blank"
                rel="noreferrer"
              >
                こちら
              </a>
              をご確認ください。併せて兼務職員についての考え方についても
              <a
                href={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/≪別紙≫兼務職員の取り扱いについて.pdf`}
                target="_blank"
                rel="noreferrer"
              >
                こちら
              </a>
              からご確認ください。
            </>
          }
        />
      </Box>

      {parts.map((part, index) =>
        part === "ヘルプマーク②" ? (
          <TkHelpIcon
            key={index}
            helpMessage={
              <>
                兼務職員については
                <a
                  href={`${
                    process.env.PUBLIC_URL ?? ""
                  }/assets/pdf/「兼務職員」.pdf`} //TODO ファイルパス不明
                  target="_blank"
                  rel="noreferrer"
                >
                  こちら
                </a>
                をご確認ください。
              </>
            }
          />
        ) : (
          part
        )
      )}

      <TkInfoManual rule={"<"}>{infoManualThree}</TkInfoManual>

      {state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={
            businessState.common?.contractorNo! +
            ":" +
            businessState.common?.contractorName!
          }
        />
      )}
      <TkTitle size="medium">
        {`${businessStateData?.facilityNo}:${
          businessStateData?.facilityName
        }　[施設種類]${
          FacilityKind[
            businessStateData?.facilityKind as keyof typeof FacilityKind
          ]
        }`}
      </TkTitle>

      <Box className="buttonGroup">
        <TkButton onClick={() => handleRegistration()} disabled={showButton}>
          職員登録
        </TkButton>
        <Link
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/職員情報登録様式.xlsm`}
        >
          <TkButton>職員情報登録様式のダウンロード</TkButton>
        </Link>
        <TkCsvUpload
          buttonName="職員情報登録様式のアップロード"
          type="houjinStaffInfo"
          onSuccess={handleUpload}
          disabled={showButton}
        />
        <TkButton onClick={() => handReplacement()}>配置換え登録</TkButton>
      </Box>

      <TkTable headList={tableHeadList} bodyList={BodyList} />

      <Box className="checkBox">
        <TkCheckbox
          label="以下に該当する職員はすべて登録しました"
          checked={disOver}
          onChange={() => {
            setDisOver(!disOver);
          }}
          data-testid="checkbox"
        />
      </Box>
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC050104_02}</TkInfoManual>

      <Box className="buttonGourpBottom">
        <TkBackButton />
        <TkButton
          data-testid="registerSuccess"
          onClick={() => onHandleUpdateAPI()}
          disabled={!disOver}
        >
          登録完了
        </TkButton>
      </Box>

      <TkMessageDialog
        open={openSuccessDelete}
        onOky={() => {
          handleOKDelete();
        }}
        onCancel={() => setOpenSuccessDelete(false)}
        title="確認（職員情報を削除します）"
        contextText="　職員情報の削除を行いますが、問題ないでしょうか。"
        cancelText="いいえ"
        okText="はい"
      />
      <TkMessageDialog
        open={openUploadComplete}
        onOky={() => {
          setOpenUploadComplete(false);
        }}
        title="アップロード完了"
        contextText="　アップロードが完了しました。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};
export default SCRC050104;
